import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CSidebar, CSidebarNav } from '@coreui/react'
import { AppSidebarNav } from './AppSidebarNav'
import { _nav } from '../_nav'
import { useLocation } from 'react-router'
import AppFooter from './AppFooter'
import { setVisible, setExpanded } from '../slice'
import { useLanguage } from './context/LanguageContext'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import CIcon from '@coreui/icons-react'
import { cilSettings } from '@coreui/icons'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  // let visible = useSelector(state => state.sidebar.visible)
  let minimize = useSelector(state => state.sidebar.minimize)
  const [navWithCustomFilters, setNavWithCustomFilters] = useState(_nav)
  const [loadingCustomFilters, setLoadingCustomFilters] = useState(false)

  const languageContext = useLanguage()

  // Fetch custom filters and enhance nav menu
  useEffect(() => {
    const fetchAndEnhanceNav = async () => {
      setLoadingCustomFilters(true)
      try {
        const response = await fetch(`${process.env.REACT_APP_API}licitatii-custom-filters`, {
          method: 'GET',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        })
        if (response.ok) {
          const result = await response.json()
          const savedFilters = result.data?.data || []
          
          // Create new nav with custom filters injected
          const newNav = _nav.map(item => {
            if (item.name === 'Licitatii') {
              const customFilterItems = savedFilters.map(filter => ({
                name: filter.name,
                to: `/licitatii/custom/${filter.id}`,
                icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
                permission: 'licitatii-centralizator-read',
              }))
              return {
                ...item,
                children: [...item.children, ...customFilterItems],
              }
            }
            return item
          })
          
          setNavWithCustomFilters(newNav)
        }
      } catch (error) {
        console.error('Error fetching custom filters for nav:', error)
      } finally {
        setLoadingCustomFilters(false)
      }
    }
    
    fetchAndEnhanceNav()
    
    // Listen for custom filter updates from LicitatiiCentralizator
    const handleFiltersUpdated = () => {
      fetchAndEnhanceNav()
    }
    
    window.addEventListener('customFiltersUpdated', handleFiltersUpdated)
    
    return () => {
      window.removeEventListener('customFiltersUpdated', handleFiltersUpdated)
    }
  }, [])

  return (
    <CSidebar
      narrow={minimize}
      unfoldable={minimize}
      // visible={visible}
      // onVisibleChange={visible => {
      //   dispatch(setVisible(visible))
      // }}
      className="side-bar"
    >
      <CSidebarNav className={minimize ? 'p-2' : ''}>
        <AppSidebarNav items={navWithCustomFilters} />
      </CSidebarNav>
      <div className="side-bar-toggler">
        {/* {visible && ( */}
        <span onClick={() => dispatch(setExpanded(minimize))} className="side-bar-icon">
          {minimize ? (
            <FaArrowRight size={15} title={languageContext?.t('Expand')} />
          ) : (
            <FaArrowLeft size={15} title={languageContext?.t('Collapse')} />
          )}
        </span>
        {/* )} */}
      </div>
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
